import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import PageBanner from '../components/page-banner/page-banner.component';
import RecentNews from '../components/recent-news/recent-news.component';

type InTheNewsPageProps = {
  data: GatsbyTypes.StrapiLinkedArticlesQuery;
};

export const query = graphql`
  query StrapiLinkedArticles {
    allStrapiLinkedArticle(
      filter: { status: { eq: "published" } }
      sort: { fields: publishedAt, order: DESC }
    ) {
      edges {
        node {
          title
          hyperlink
        }
      }
    }
  }
`;

const InTheNewsPage: React.FC<InTheNewsPageProps> = ({ data }) => {
  return (
    <>
      <Helmet title="In The News" />
      <PageBanner
        pageTitle="In the News"
        homePageText="Home"
        homePageUrl="/"
        activePageText="In the News"
      />
      <RecentNews
        title="Articles Hop In is Featured In"
        subtitle="News"
        news={data.allStrapiLinkedArticle.edges.map(
          ({ node: { title, hyperlink } }) => ({
            name: title,
            link: hyperlink,
            fillColumn: true,
          })
        )}
      />
    </>
  );
};

export default InTheNewsPage;
